import { render } from "./PageNav.vue?vue&type=template&id=e00123be&ts=true"
import script from "./PageNav.vue?vue&type=script&lang=ts"
export * from "./PageNav.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__